import $ from 'jquery';

import { updateTotalPrice } from './showroom-utilities.js';
// calculator already initialized with the payment-calculations.js

// Cash Incentives
const $summaryBreakdown = $('.summary-breakdowns');

const configuredCashTotal = $summaryBreakdown.data('configured');
const configuredFinanceTotal = $summaryBreakdown.data('configured-finance');
const configuredLeaseTotal = $summaryBreakdown.data('configured-lease');

// bottom form
const formPrice = $('.bottom-form .dsp_dynamic_price input');

// the element that stores price
// finance and lease updates are handled using payment-calculator.js
const $bottomBarTotals = {
  cash: $('.cash-breakdowns .bottom-bar--total'),
  finance: $('.finance-breakdowns .bottom-bar--total'),
  lease: $('.lease-breakdowns .bottom-bar--total'),
};

$('.js-targeted-incentive.cash').on('change', function (e) {
  e.preventDefault();
  updateTotalPrice(configuredCashTotal, $bottomBarTotals['cash'], 'cash', formPrice);
});

$('.js-targeted-incentive.finance').on('change', function (e) {
  e.preventDefault();
  updateTotalPrice(configuredFinanceTotal, $bottomBarTotals['finance'], 'finance');
});

$('.js-targeted-incentive.lease').on('change', function (e) {
  e.preventDefault();
  updateTotalPrice(configuredLeaseTotal, $bottomBarTotals['lease'], 'lease');
});
